import css from '@utils/css'
import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React from 'react';

const FieldFeedback = ({ children, mods={}, invalid, valid, className: classNameTail }) => {
    const { className } = useMods(FieldFeedback, { mods: { ...mods, invalid, valid } });

    return (
        <span
            className={ css(className, classNameTail) }
        >
            { children }
        </span>
    );
};

FieldFeedback.displayName = 'Field__Feedback';

FieldFeedback.propTypes = {
    children: PropTypes.node,
    invalid: PropTypes.bool,
    mods: PropTypes.object,
    valid: PropTypes.bool
};

export default FieldFeedback;
